// Determine the ENV front-end is running on based off browser URL
function getStageByDomain() {
  const url = window.location.hostname

  // Determine deployment stage by browser's location
  if (url.indexOf('localhost') > -1) return 'local'; // 'localhost:8020/api/v1';
  else if (url.indexOf('stage.') > -1 || url.indexOf('stage-') > -1) return 'stage'; // 'stage-portal-sha.narrasys.com'
  else return 'prod'; // 'soilhealthacademy.narrasys.com'

}

export {
  getStageByDomain
};